import { Component } from '@angular/core';
import { NavbarComponent } from "../../partials/navbar/navbar.component";
import { FooterComponent } from "../../partials/footer/footer.component";
import { LanguageService } from '../../services/language.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-terms-online-sale',
  standalone: true,
  imports: [NavbarComponent, FooterComponent, CommonModule],
  templateUrl: './terms-online-sale.component.html',
  styleUrl: './terms-online-sale.component.css'
})
export class TermsOnlineSaleComponent {
  texts: any;

  constructor(private langServ: LanguageService) {
    this.texts = this.langServ.getWebisteTexts().termsOnlineSale;
  }
}
